// src/config.js
export const API_URL = process.env.REACT_APP_API_URL;
export const OSRM_HOST = process.env.REACT_APP_OSRM_HOST;
